import { render } from "./SubmissionStatusForm.vue?vue&type=template&id=837dffee&ts=true"
import script from "./SubmissionStatusForm.vue?vue&type=script&lang=ts"
export * from "./SubmissionStatusForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__